<template>
  <div class="incenters">
    <!-- style="border: 1px solid red;" -->
    <div>
      <!-- <Commonbtn title="导出"></Commonbtn> -->
      <div class="topstate" v-for="(item , index) of state" :key="index" :class="[{ 'ativte' : onchage == index}]" @click="clicktab(index)">
        {{ item.title }}
      </div>
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div class="TableWidth" v-if="tableflag" style="overflow-x: scroll;">
      <Commontable :rowhe="false"  colnum=7 :loadingTable="loadingTable" :tableData="tableDataDetail" :headerData="headerData" height="100%"></Commontable>
    </div>
    <div class="TableWidth" v-if="tableflags">
      <Commontable :CusFlag="CusFlag" :loadingTable="loadingTable" colnum=3 :tableData="tableDataUnique" height="100%"></Commontable>
    </div>
  </div>
</template>

<script>
import Commontable from '../../../../components/common-table.vue'
import Commonbtn from '../../../../components/common-btn.vue'
import {
  SaleBillDetail,
  SaleBillDetailUnique,
  CusType
} from '@/api/home'
export default {
  components: {
    Commontable,
    Commonbtn,
  },
  props: ['sbmid', 'tableDataUnique', 'tableDataDetail'],
  data: function () {
    return {
      loadingTable: false,
      tableData1: [],
      tableData: [],
      tableDataUniques: [],
      headerData: [{
        prop: 'id',
        label: '序号',
        columnwidth: 50
      },
      {
        prop: 'InvCode',
        label: '商品编号',
        columnwidth: 120
      },
      {
        prop: 'InvAddCode',
        label: '商品代码',
        columnwidth: 180
      },
      {
        prop: 'InvName',
        label: '存货名称',
        columnwidth: 180
      },
      {
        prop: 'Batch',
        label: '批号',
        columnwidth: 110
      },
      {
        prop: 'Quantity',
        label: '数量',
        columnwidth: 50
      },
      {
        prop: 'NatSum',
        label: '本币价税合计',
        columnwidth: 90,
      },
      {
        prop: 'NatTaxPrice',
        label: '本币去税金额',
        columnwidth: 90,
      },
      {
        prop: 'NatMoney',
        label: '本币税额',
        columnwidth: 90,
      },
      {
        prop: 'TaxRate',
        label: '税率',
        columnwidth: 90,
      },
      {
        prop: 'ExchangeRate',
        label: '汇率',
        columnwidth: 90,
      },
      {
        prop: 'TaxUnitPrice',
        label: '原币含税单价',
        columnwidth: 90,
      },
      {
        prop: 'VouCode',
        label: '经销商出库单号',
        columnwidth: 100,
      },
      {
        prop: 'VouDCode',
        label: '来源单据明细行号',
        columnwidth: 100,
      },
      {
        prop: 'ValiDate',
        label: '有效期至',
        columnwidth: 100,
      },
      {
        prop: 'UnitPrice',
        label: '原币单价',
        columnwidth: 80,
      }
      ],
      state: [{
        title: '明细'
      },
      {
        title: '发票图片'
      }
      ],
      onchage: 0,
      CusFlag: null,
      tableflag: true,
      tableflags: false,
      tableDataSaleBillDetail: [],
      tableDataSaleBillDetailUnique: [],
    }
  },
  created() {
  },
  mounted() {
    this.SaleBillDetail()
    this.CusType()
  },
  methods: {
    // 明细
    async SaleBillDetail() {
      let {
        data,
        code
      } = await SaleBillDetail({
        sbmid: this.sbmid
      })
      if (code == 0) {
        this.tableDataDetail = data 
      }
    },
    // 唯一码
    async SaleBillDetailUnique() {
      let {
        data,
        code
      } = await SaleBillDetailUnique({
        sbmid: this.sbmid
      })
      if (code == 0) {
        this.tableDataUnique = data
      }
    },
    async CusType() {
      let {
        data,
        code
      } = await CusType({})
      if (code == 0) {
        if (data.CusType == "") {
          this.CusFlag = 1
        }
      }
    },
    clicktab(index) {
      if (index == 0) {
        this.tableflag = true
        this.tableflags = false
        this.SaleBillDetail()
      }
      if (index == 1) {
        this.tableflag = false
        this.tableflags = true
        this.SaleBillDetailUnique()
      }
      if (this.onchage != index) {
        this.onchage = index
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ativte {
  border: 1px solid red;
  color: #e71d43;
  background-color: #fce8ec;
  transition: 0.2s linear;
}

.incenters {
  height: 100%;
  font-family: "微软雅黑";
  width: 980px;
  margin-top: 10px;
  padding-bottom: 10px;
  padding-top: 2px;
    background-color: rgb(255, 255, 255);
    box-shadow: rgb(0 0 0 / 10%) 0px 1px 4px 0px;
  div {
    margin-left: 8px;
    margin-right: 8px;
    margin-top: 5px;
    margin-bottom: 5px;
    // width: 100%;
  }
}

.topstate {
  width: 100px;
  height: 32px;
  font-size: 14px;
  border: 1px solid #e6e6e6;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
}
</style>
